import { Grid } from "@material-ui/core";
import XCarousel from "common/X/XCarousel";
import React from "react";
import { IMyActivitiesPrizesWon } from "redux/types/myActivities";
import MyActivityPrizesWonCard from "./MyActivityPrizesWonCard";

interface IProps {
  classes: any;
  myActivitiesPrizesWon: IMyActivitiesPrizesWon;
}

function MyActivityPrizesWon(props: IProps) {
  const { myActivitiesPrizesWon } = props;

  return (
    <Grid
      container
      spacing={2}
      direction="row"
      style={{ marginBottom: 32, padding: "0 8px" }}
    >
      <XCarousel itemsToShow={2} infinite={true} partialVisible={true}>
        {myActivitiesPrizesWon?.result?.length > 0 &&
          myActivitiesPrizesWon?.result?.map((prize) => (
            <MyActivityPrizesWonCard key={prize?.prizeId} prize={prize} />
          ))}
      </XCarousel>
    </Grid>
  );
}

export default MyActivityPrizesWon;
